// SPDX-License-Identifier: Apache-2.0

import { Assertion } from '../../types/api'
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import { theme } from '../../helpers/theme'
import MqStatus from '../core/status/MqStatus'
import MqText from '../core/text/MqText'
import React from 'react'
import { IState } from '../../store/reducers'
import { useSelector } from 'react-redux'
import { borderWhite, borderBlack } from '../../helpers/theme'

interface OwnProps {
  assertions: Assertion[]
  hasHeader?: boolean
}

const Assertions: React.FC<OwnProps> = ({ assertions, hasHeader }) => {
  if (assertions.length === 0) {
    return null
  }
  const { theme: iframeTheme } = useSelector((state: IState) => state.iframe)
  return (
    <Table size={'small'}>
      {hasHeader && (
        <TableHead>
          <TableRow>
            <TableCell align={'left'} sx={{ borderBottomColor: iframeTheme === 'dark' ? borderBlack : borderWhite }} >
              <MqText bold>COLUMN</MqText>
            </TableCell>
            <TableCell align={'left'} sx={{ borderBottomColor: iframeTheme === 'dark' ? borderBlack : borderWhite }} >
              <MqText bold>ASSERTION</MqText>
            </TableCell>
            <TableCell align={'left'} sx={{ borderBottomColor: iframeTheme === 'dark' ? borderBlack : borderWhite }} >
              <MqText bold>STATUS</MqText>
            </TableCell>
          </TableRow>
        </TableHead>
      )}
      <TableBody>
        {assertions.map((assertion) => {
          const sx = { borderBottom: 'none', borderBottomColor: iframeTheme === 'dark' ? borderBlack : borderWhite }
          return (
            <TableRow key={`${assertion.column}-${assertion.assertion}`}>
              <TableCell align={'left'} sx={sx}>
                <MqText font={'mono'}>{assertion.column}</MqText>
              </TableCell>
              <TableCell align={'left'} sx={sx}>
                <MqText subdued>{assertion.assertion}</MqText>
              </TableCell>
              <TableCell align={'left'} sx={sx}>
                {
                  <MqStatus
                    label={assertion.success ? 'pass'.toUpperCase() : 'fail'.toUpperCase()}
                    color={
                      assertion.success ? theme.palette.primary.main : theme.palette.error.main
                    }
                  ></MqStatus>
                }
              </TableCell>
            </TableRow>
          )
        })}
      </TableBody>
    </Table>
  )
}

export default Assertions
